import styled from 'styled-components';

import { SmallSubtitle } from '../../../../../foundations/typefaces/SmallSubtitle';

export const Wrapper = styled.div(({ theme: { size, color } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: `${size.units(0.5)} ${size.units(0.5)} 0 ${size.units(0.5)}`,

  '&:focus-visible': {
    outline: `2px solid ${color.border.accent.default()}`,
  },
}));

export const StyledSmallSubtitle = styled(SmallSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  textTransform: 'uppercase',
  fontWeight: 700,
}));
